import { z } from "zod";

import { auditDate } from "@/schemas";

import { medRoomChecklistItem } from "../../../schemas";

export const crisisMedRoomStep1Schema = z.object({
  auditDate: auditDate,
  locationId: z.string().min(1, "Required"),
  reviewerId: z.string().min(1, "Required"),
  handHygienePosted: medRoomChecklistItem,
  firstAidKit: medRoomChecklistItem,
  ppePresent: medRoomChecklistItem,
  medRoomClean: medRoomChecklistItem,
  medInternalExternal: medRoomChecklistItem,
  medClosetTemp: medRoomChecklistItem,
  medClosetLight: medRoomChecklistItem,
  stockMedSeparate: medRoomChecklistItem,
  stockMedLabel: medRoomChecklistItem,
  earEyeMed: medRoomChecklistItem,
  orderedMedLabeled: medRoomChecklistItem,
  medSupplies: medRoomChecklistItem,
  individualMedSeparated: medRoomChecklistItem,
});

export const crisisMedRoomStep2Schema = z
  .object({
    medLocked: medRoomChecklistItem,
    controlledSubstanceLog: medRoomChecklistItem,
    controlledSubstanceLocked: medRoomChecklistItem,
    controlledSubstanceLockedFridge: medRoomChecklistItem,
    expiredMed: medRoomChecklistItem,
    medDestructionArea: medRoomChecklistItem,
    emergencyMed: medRoomChecklistItem,
    medPrepared: medRoomChecklistItem,
    sharpsContainer: medRoomChecklistItem,
    foodStorage: medRoomChecklistItem,
    medRefrigeratorTemperature: medRoomChecklistItem,
    doNotUseAbbreviation: medRoomChecklistItem,
    lookAlikeSoundAlike: medRoomChecklistItem,
    highAlertMed: medRoomChecklistItem,
    medCount: medRoomChecklistItem,
    fileMedCount: z.union([z.instanceof(File), z.null()]).optional(),
  })
  .superRefine((data, ctx) => {
    const medCountSize = data.fileMedCount?.size ?? 0;

    if (medCountSize > 2 * 1024 * 1024) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Max 2 MB",
        path: ["fileMedCount"],
      });
    }
  });

export const crisisMedRoomStep3Schema = z
  .object({
    cliaWaivedTest: medRoomChecklistItem,
    testSpecimenLabeled: medRoomChecklistItem,
    waivedTestingControls: medRoomChecklistItem,
    controlledDrugCount: medRoomChecklistItem,
    controlledDrugSignOff: medRoomChecklistItem,
    controlledMedInvestigated: medRoomChecklistItem,
    disposalForm: medRoomChecklistItem,
    fileDisposalForm: z.union([z.instanceof(File), z.null()]).optional(),
  })
  .superRefine((data, ctx) => {
    const disposalSize = data.fileDisposalForm?.size ?? 0;

    if (disposalSize > 2 * 1024 * 1024) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Max 2 MB",
        path: ["fileDisposalForm"],
      });
    }
  });
